import type { AiAppCenterModule } from '../types'

export const geoAgentModule: AiAppCenterModule = {
  key: 'geoAgent',
  label: 'GEO智能体',
  desc: 'GEO 看板 / 数据监控 / 智能助手 / 内容发布',
  path: '/geo',
  homePath: '/geo/dashboard',
  // 侧栏挂整棵 /geo；勿只写叶子 path，否则独立窗只剩「GEO仪表盘」
  icon: 'ep:magic-stick',
  color: '#d946ef',
  aliases: ['GEO 智能体', '控制台GEO', 'GEO控制台', 'GEO 控制台']
}
